import { makeObservable, observable, flow, computed } from "mobx";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import BrowseRisksSummarySchema from "@/areas/risks/schemas/BrowseRisksSummarySchema";
import { RiskConstants } from "./RiskConstants";

export default class BrowseRisksSummaryStore {
  loading = true;
  query = { search: "", page: 1 };
  summary = {};

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      summary: observable,
      actions: computed,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  get actions() {
    const list = [];

    return list;
  }

  *load(query, options) {
    const parseResult = BrowseRisksSummarySchema.safeParse(query);
    if (!parseResult.success) {
      console.error(parseResult.error);
      return parseResult;
    }
    try {
      this.loading = true;

      const existingQuery = query.query;

      const storedRiskTypes = JSON.parse(localStorage.getItem(RiskConstants.StateKeys.RiskTypes)) ?? [];
      const storedRiskTypeIds = storedRiskTypes.map((x) => x.id);
      const updatedQuery = { ...existingQuery, typeId: storedRiskTypeIds };

      const response = yield api.post(ApiRoutes.forRisksSummary(), { ...query, query: updatedQuery });
      this.summary = response.data;

      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
